import { render, staticRenderFns } from "./popupalert.vue?vue&type=template&id=04464398&scoped=true&"
import script from "./popupalert.vue?vue&type=script&lang=js&"
export * from "./popupalert.vue?vue&type=script&lang=js&"
import style0 from "./popupalert.vue?vue&type=style&index=0&id=04464398&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04464398",
  null
  
)

export default component.exports